<div [class]="chart.ChartSize" *ngIf="chartData || chartData === 0">

  <div class="butpro" (click)="navigateTo()">
    <div class="sub">
      <h2>{{chartLabel}}</h2>
      <span [countUp]="chartData" [style.color]="chartColor ? chartColor : ''">0</span>
    </div>
    <!-- <div class="stat" *ngIf="chart.ChartIcon">
      <i [class]="chart.ChartIcon" [style.color]="chartColor ? chartColor : ''"></i>
    </div> -->
  </div>

</div>